import { EnableKey } from '@mygpt/app/apis/services/plan';
// import { useSubscriptionStore } from '@mygpt/app/subscription/store';

// 默认不可以访问，触发接口返回true
export const useCanAccess = (accessKey: EnableKey) => {
  // const { subscriptionInfo } = useSubscriptionStore();

  // if (!subscriptionInfo) {
  //   return false;
  // }

  // if (subscriptionInfo[accessKey] === false) {
  //   return false;
  // }

  return true;
};
